import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Works/Worlds/CodeSurvival/HP_CodeSurvival_arms1.png'
import _imports_1 from '@/assets/Works/Worlds/CodeSurvival/HP_CodeSurvival_arms2.png'


import TitleCard from '@/components/utils/TitleCard.vue';
import BaseArticle from '@/components/Works/baseArticle.vue';
import DefaultCarousel from '@/components/Works/defaultCarousel.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CodeSurvivalView',
  setup(__props) {

const videoIds = [
  '7xZwQdOsvUM',
  'G52AYzpK6gs',
  'b5UYokxXX-A'
]

return (_ctx: any,_cache: any) => {
  const _component_q_video = _resolveComponent("q-video")!
  const _component_q_carousel_slide = _resolveComponent("q-carousel-slide")!

  return (_openBlock(), _createBlock(BaseArticle, {
    "product-name": "Code:Survival",
    imgsrc: require('@/assets/Works/Worlds/CodeSurvival.jpg'),
    "download-link": "https://drive.google.com/uc?id=1D5p-Rag4IQteEbSkkfju4fq4LFcpzIFS"
  }, {
    default: _withCtx(() => [
      _createVNode(TitleCard, {
        title: "荒廃した世界で一人称RTS!",
        abst: [
        '舞台は、文明が一度滅んだ世界。',
        'ロボットである自分たちは、生きるために必要な鉱石を採掘して暮らしている。',
        'ガンタレットとバリケードを駆使して、採掘の邪魔をしてくるロボットから採掘機を守り切れ！',
      ]
      }),
      _createVNode(TitleCard, { title: "紹介映像" }, {
        abst: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(videoIds, (id) => {
            return _createVNode(_component_q_video, {
              key: id,
              src: `https://www.youtube.com/embed/${id}`,
              class: "innerAssets q-pa-md"
            }, null, 8, ["src"])
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(TitleCard, {
        title: "Real-Time Strategy(RTS)とは？",
        abst: [
        'Real-time Strategy(RTS)とは、リアルタイムで進行する戦況を俯瞰視点で捉え、戦略を立てて敵と戦うゲームです。',
        'この配布ワールドでは、俯瞰視点ではなく一人称で敵に対応して採掘機を守ります。',
      ]
      }, null, 8, ["abst"]),
      _createVNode(TitleCard, {
        title: "採掘機の防衛",
        abst: [
        '採掘機を作動させると、敵が察知して30秒後に襲撃してきます。',
        '敵は最短経路で採掘機に向かってくるので経路を考え、アームズを駆使して採掘機を守りましょう！',
      ]
      }, {
        abst: _withCtx(() => [
          _createVNode(DefaultCarousel, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_carousel_slide, {
                name: 1,
                "img-src": _imports_0
              }),
              _createVNode(_component_q_carousel_slide, {
                name: 2,
                "img-src": _imports_1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(TitleCard, {
        title: "ダウンロード",
        abst: [
        '右下の丸いアイコンから、規約に同意することでダウンロードできます。',
        '対応バージョン：Minecraft 1.14.4  シングルプレイ専用',
        '必須ソフトウェア：OptiFine',
        '※なお、本作はアップデートを予定していたため引継ぎアイテムが生成できますが、現在諸事情によりアップデートは無期限延期となっております。ご了承ください。'
      ]
      }, null, 8, ["abst"])
    ]),
    _: 1
  }, 8, ["imgsrc"]))
}
}

})